/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../utils/service";

const useStopSurvey = (surveyId) =>
  useMutation({
    mutationKey: ["stopSurvey", surveyId],
    mutationFn: (surveyId) => service.stopSurvey(surveyId),
  });

export default useStopSurvey;
